/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */

import React from "react";
import { connect } from "react-redux";
import { cart, showMiniCart, myFav } from "../../../../models";
import { pdt, lock } from "hf-rt";
import { Translation } from "react-i18next";
import "../../../../css/AddToCart.css";
import { setGAEvent } from "../../../../function/setGAEvent";

class AddToCart extends React.Component {
  state = {
    lock: false
  };

  handleClick = async qtys => {
    const { cbu, quantity, addToCart, fetchCart } = this.props;
    const order = {
      cbu,
      quantity
    };

    if (order.cbu.trim() === "") return;

    setGAEvent(
      "add_to_cart",
      this.props.product,
      this.props.productBookingUnit
    );

    await this.setState({
      lock: true
    });
    await addToCart(order);
    await fetchCart();
    await this.setState({
      lock: false
    });
    await this.props.showMiniCart(true);
  };

  handleAddWishList = () => {
    const { product, wishListData } = this.props;
    if (!wishListData) {
      return;
    }
    const found = wishListData.wishListItems.findIndex(
      data => data.channelCatalogItemCode === product.code
    );
    if (found !== -1) {
      // 已在願望清單，移除自己
      this.props.removeFromMyFav(product.code);
    } else {
      // 不在願望清單，加入自己
      const data = {
        channelCatalogItemCode: product.code
      };
      this.props.addToMyFav(data);
    }
  };

  isWishList = () => {
    const { product, wishListData } = this.props;
    if (wishListData && product) {
      const { code } = product;
      const found = wishListData.wishListItems.findIndex(
        data => data.channelCatalogItemCode === code
      );
      if (found !== -1) {
        return "active";
      } else {
        return "";
      }
    } else {
      return "";
    }
  };

  render() {
    const { qtys } = this.props;
    return (
      <>
        <div className="addToBtns_wrap">
          <a
            className="blockBtn addToCart_btn"
            onClick={pdt.isOutOfStock(
              qtys,
              lock(this.state.lock, () => this.handleClick(qtys))
            )}
            style={{ width: "100%", margin: "0" }}
          >
            <Translation>{t => <>{t("addToCart.addBag")}</>}</Translation>
          </a>
        </div>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    productBookingUnit: state.product.productBookingUnit,
    cbu: state.product.productBookingUnit.cbu,
    maxQuantity: state.product.productBookingUnit.quantity,
    quantity: state.order.quantity,
    accessory: state.order.accessory,
    wishListData: state.myFav.wishListItems,
    getWishListSuccessfully: state.myFav.getWishListSuccessfully,
    product: state.product.product
  };
};
const mapDispatchToProps = () => {
  return {
    addToCart: order => cart.actions.addToCart(order),
    fetchCart: () => cart.actions.fetchCart(),
    showMiniCart: bool => showMiniCart.actions.showMiniCart(bool),
    addToMyFav: wishItemCode => myFav.actions.addToMyFav(wishItemCode),
    removeFromMyFav: wishItemCode => myFav.actions.removeFromMyFav(wishItemCode)
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(AddToCart);
